import { rangePresets } from '@gogame/intl-ts';

export const COLUMN_POSTBACK_DATE = 'postbackDate';
export const COLUMN_APPLICATION_NAME = 'applicationName';
export const COLUMN_AFFILIATE_NAME = 'affiliateName';
export const COLUMN_CAMPAIGN_ID = 'campaignId';
export const COLUMN_CAMPAIGN_NAME = 'campaignName';
export const COLUMN_REG_ACTION_ID = 'regActionId';
export const COLUMN_REGISTRATION_DATE = 'registrationDateTime';
export const COLUMN_AD_CLICK_ID = 'adClickId';
export const COLUMN_EVENT_TIME = 'eventTime';
export const COLUMN_EVENT_NAME = 'eventName';
export const COLUMN_POSTBACK_URL = 'postbackUrl';

export const FILTER_PERIOD = 'period';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_AFFILIATES = 'affiliateIds';
export const FILTER_EVENTS = 'eventIds';

export const FILTER_DEPENDENCIES = {};

export const PERIOD_PRESETS = [
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_MONTH,
];

export const POSTBACKS_REPORT_PAGE = 6;
